module.exports = {"component":"setup-assistant","status":"prototype","display-name":"Setup Assistant","SLDS-component-path":"/components/setup-assistant","dependencies":[{"component":"step"}],"url-slug":"setup-assistant"}


//////////////////
// WEBPACK FOOTER
// ./components/setup-assistant/docs.json
// module id = 328
// module chunks = 0